import React from 'react';
import { observer } from 'mobx-react-lite';
import { SearchUiState } from './SearchTermUiState';
import { AllOption } from './SingleOriginFilterState';
import classNames from "./SelectSingleSearchTermControl.module.css";

export const SelectSingleSearchTermControl = observer((({ searchUiState }: { searchUiState: SearchUiState; }) => {
	return (
		<div className={classNames.SelectSingleSearchTermControl}>
			<label>Show only search term:&nbsp;
				<select value={searchUiState.showOnlySearchTerm}
					onChange={(e) => searchUiState.setShowOnlySearchTerm(e.currentTarget.value)}
				>
					<option value="">All</option>
					{searchUiState.searchTerms.map((searchTerm) => (
						<option key={searchTerm} value={searchTerm}>{searchTerm}</option>
					))}
				</select>
			</label>
			<label>Data flow&nbsp;
				<select value={searchUiState.dataFlowDirection}
					onChange={(e) => searchUiState.setDataFlowDirection(e.currentTarget.value)}>
					<option value={AllOption}>All</option>
					<option value="sent">Sent</option>
					<option value="received">Received</option>
				</select>
			</label>
		</div>
	);
}));
